import React, { createContext, useContext } from 'react';

interface SessionContextType {
  loading: boolean;
  doesSessionExist: boolean;
  accessTokenPayload: unknown;
  refetch?: () => Promise<void>;
}

interface SuperTokensSessionContextType {
  loading: boolean;
  doesSessionExist?: boolean;
  accessTokenPayload?: unknown;
  refetch?: () => Promise<void>;
}

type UseSessionContextHook = () =>
  | SessionContextType
  | SuperTokensSessionContextType;

const SessionContextProviderContext =
  createContext<UseSessionContextHook | null>(null);

interface SessionContextProviderProps {
  children: React.ReactNode;
  useSessionContext: UseSessionContextHook;
}

export const SessionContextProvider: React.FC<SessionContextProviderProps> = ({
  children,
  useSessionContext,
}) => {
  return (
    <SessionContextProviderContext.Provider value={useSessionContext}>
      {children}
    </SessionContextProviderContext.Provider>
  );
};

export const useProvidedSessionContext = (): SessionContextType => {
  const useSessionContextHook = useContext(SessionContextProviderContext);
  if (!useSessionContextHook) {
    throw new Error(
      'useProvidedSessionContext must be used within a SessionContextProvider',
    );
  }

  const rawSession = useSessionContextHook();

  return {
    loading: rawSession.loading,
    doesSessionExist: rawSession.doesSessionExist ?? false,
    accessTokenPayload: rawSession.accessTokenPayload ?? null,
  };
};
